(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !window.DesignMode) return;
  try {
    

function initMarquee() {
  document.querySelectorAll('.logo-list--carousel .logo-list__list').forEach(list => {
    if (list.dataset.marquee === 'on') return;
    list.dataset.marquee = 'on';

    const parent = list.closest('.scroller');
    const gapPx = 32;
    const speed = 40;
    
    const originalItems = Array.from(list.children).filter(item =>
      item.querySelector('img')
    );
    const getSetWidth = () => originalItems.reduce((sum, item) => {
      const itemWidth = item.getBoundingClientRect().width;
      return sum + itemWidth + gapPx;
    }, 0);

    const containerWidth = parent.offsetWidth;
    let oneSetWidth = getSetWidth();

    while (list.scrollWidth < containerWidth * 3) {
      originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        list.appendChild(clone);
      });
      oneSetWidth = getSetWidth(); 
    }

    let pos = 0;
    let paused = false;

    function animate() {
      if (!paused) {
        pos -= speed / 60;
        if (Math.abs(pos) >= oneSetWidth) {
          pos = 0;
        }
        list.style.transform = `translateX(${pos}px)`;
      }
      requestAnimationFrame(animate);
    }

    parent.addEventListener('mouseenter', () => paused = true);
    parent.addEventListener('mouseleave', () => paused = false);

    requestAnimationFrame(animate);
  });
}
document.addEventListener('DOMContentLoaded', initMarquee);
document.addEventListener('shopify:section:load', initMarquee);

  } catch(e) { console.error(e); }
})();
})();
